import { render } from "./TDBG_SRLQ.vue?vue&type=template&id=1fda1576&scoped=true"
import script from "./TDBG_SRLQ.vue?vue&type=script&lang=js"
export * from "./TDBG_SRLQ.vue?vue&type=script&lang=js"

import "./TDBG_SRLQ.vue?vue&type=style&index=0&id=1fda1576&lang=css"
import "./TDBG_SRLQ.vue?vue&type=style&index=1&id=1fda1576&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fda1576"]])

export default __exports__